wbApp.directive('wbNumberEdit', [
    function () {
    return {
        restrict: 'EA',
        require: '?ngModel',
        link: function (scope, element, attr, ctrl) {
            ctrl.$parsers.push(function (value) {
                if (ctrl.$isEmpty(value)) {
                    return value;
                } 

                if (typeof value == 'string' || value instanceof String) {

                    var transformedInput = null;

                    if (attr.min) {
                        var min = parseFloat(attr.min);
                        if (min < 0) {
                            transformedInput = value.replace(/[^0-9]|\-/g, '');
                        }
                    }
                    if (transformedInput === null) {
                        transformedInput = value.replace(/[^0-9]/g, '');
                    }
                    if (transformedInput !== value) {
                         ctrl.$viewValue = transformedInput;
                         ctrl.$render();
                    }

                    return parseInt(transformedInput || 0);
                }

                return value;
            });

            ctrl.$formatters.unshift(function (value) {
                if (ctrl.$isEmpty(value)) {
                    return value;
                } else {
                    return value + "";
                }
            });

            function validate(ctrl, validatorName, validity, value) {
                ctrl.$setValidity(validatorName, validity);
                return validity ? value : undefined;
            }

            if (attr.min) {
                var minValidator = function (value) {
                    var min = parseFloat(attr.min);
                    return validate(ctrl, 'min', ctrl.$isEmpty(value) || value >= min, value);
                };

                ctrl.$parsers.push(minValidator);
                ctrl.$formatters.push(minValidator);
            }

            if (attr.max) {
                var maxValidator = function (value) {
                    var max = parseFloat(attr.max);
                    return validate(ctrl, 'max', ctrl.$isEmpty(value) || value <= max, value);
                };

                ctrl.$parsers.push(maxValidator);
                ctrl.$formatters.push(maxValidator);
            }
        }
    };
}]);